var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.regs.length > 0)?_c('div',{staticStyle:{"width":"100%"}},[_c('BarChart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }